var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMguEnrolledIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  "data-name": "Ellipse 1"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 9
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  "data-name": "building"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 4h10v11H7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5 4.5h9v10h-9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.899 5.533h2.34v2h-2.34z",
  "data-name": "Path 2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.623 5.533h2.274v2h-2.274z",
  "data-name": "Path 3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.623 8.033h2.274v2h-2.274z",
  "data-name": "Path 4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.623 10.533h2.274v2h-2.274z",
  "data-name": "Path 5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.899 8.033h2.34v2h-2.34z",
  "data-name": "Path 6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.899 10.533h2.34v2h-2.34z",
  "data-name": "Path 7"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  stroke: "#fff"
}, /*#__PURE__*/React.createElement("g", {
  strokeWidth: 2,
  "data-name": "Path 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.57 14.5H3.277V9.318c.48-.147 1.47-.468 3.57-1.17h.01l3.713 1.163z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "none",
  d: "M6.856 8.673a226 226 0 0 1-3.079 1.014v4.312h6.293V9.68zM6.83 7.649h.104l4.136 1.295V15H2.777V8.944S2.91 8.94 6.764 7.65z"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Rectangle 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6 11h2v4H6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 11.5h1v3h-1z"
})))));
export default SvgMguEnrolledIcon;